'use client'

interface TrustpilotWidgetProps {
  langIso: string
  countryIso: string
}

export const TrustpilotWidget = ({ langIso, countryIso }: TrustpilotWidgetProps) => {
  const businessUnitId = '589338330000ff00059bf342'
  const trustPilotLanguageLocale = `${langIso}-${countryIso}`

  return (
    <div
      className="trustpilot-widget"
      data-locale={trustPilotLanguageLocale}
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id={businessUnitId}
      data-style-height="100px"
      data-style-width="100%"
      data-theme="light"
    >
      <a href="https://www.trustpilot.com/review/huel.com" target="_blank" rel="noopener">
        Trustpilot
      </a>
    </div>
  )
}
